const blobCache = new Map<string, Blob>();

const getBlob = (key: string) => blobCache.get(key);

const setBlob = (key: string, blob: Blob) => {
  blobCache.set(key, blob);
};

const deleteBlob = (key: string) => {
  blobCache.delete(key);
};

const clear = () => {
  blobCache.clear();
};

const blobCacheManager = {
  getBlob,
  setBlob,
  deleteBlob,
  clear,
};

export default blobCacheManager;
